import { type CommonTranslationFunction } from '@autone/translations';

import { type UserCardConfig } from '../hooks/use-app-sidebar/useAppSidebar.types';
import { type SidebarNavigationItemProps } from '../types/Sidebar.types';

/**
 * Creates a user card item from configuration
 * @param config - User card item configuration
 * @param common - Translation function to get localized strings
 * @returns Configured user card item
 * @example
 * ```typescript
 * const userItem = createUserCardItem(
 *   {
 *     titleKey: 'settings.profile',
 *     icon: UserIcon,
 *     url: '/profile',
 *   },
 *   (key) => translate(key)
 * );
 * ```
 */
export const createUserCardItem = (
  config: UserCardConfig,
  common: CommonTranslationFunction,
): SidebarNavigationItemProps => ({
  ...config,
  title: common(config.titleKey),
  isActive: false,
  isDisabled: config.isDisabled ?? false,
});
